import PostPreviewCard from './PostPreviewCard';

export default PostPreviewCard;
